// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_wmO","cls2":"ImpactHubModal-cls2_0kp ImpactHubModal-cls1_wmO"};